<template>
  <div id="page_wallet" data-role="page">
    <header class="pageHeader">
      <div class="pageHeader_img">
        <div class="content">
          <h2 class="pageHeader_title">お財布</h2>
        </div>
      </div>
    </header>
    <section class="commingsoon">
      <div class="commingsoon_wrap">
        <h3 class="commingsoon_title">Comming soon!</h3>
        <p class="commingsoon_text">
          お財布機能により楽曲の入札や入出金がスムーズにできるようになります。<br />
          コンテンツ開始までもうしばらくお待ち下さい。
        </p>
        <div class="commingsoon_link">
          <router-link to="/" class="button-main">
            Hexabid トップページへ
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {};
</script>
